<template>
  <div class="container-fluid m-0 p-0">
    <div class="row justify-content-center mt-5">
      <div class="col-md-7 text-center">
        <h1 class="text-uppercase text-danger">Unsere Referenzen</h1>
        <h2 class="pt-4">
          Erfahrung, die begeistert – Qualität, der Sie vertrauen können
        </h2>
        <h3 class="lh-base mb-5">
          Seit über 25 Jahren sind wir Ihr zuverlässiger Partner im Trockenbau. Mit
          Leidenschaft, Präzision und innovativen Techniken schaffen wir individuelle
          Wohn- und Arbeitswelten, die begeistern.
        </h3>
        <h3 class="lh-base mb-5">
          Ob Neubau, Sanierung oder Renovierung – unser erfahrenes Team setzt Ihre
          Visionen mit höchster Sorgfalt und handwerklicher Perfektion um. Wir kombinieren
          traditionelle Werte mit modernsten Lösungen, um Ihnen nachhaltige und
          ästhetische Ergebnisse zu liefern.
        </h3>
        <h3 class="lh-base mb-5">
          Vertrauen Sie auf ein Unternehmen, das seit mehr als zwei Jahrzehnten Maßstäbe
          im Trockenbau setzt. Entdecken Sie, wie wir Ihre Räume in einzigartige
          Lebenswelten verwandeln.
        </h3>
        <h3>
          Ihr Projekt verdient das Beste – lassen Sie uns gemeinsam neue Maßstäbe setzen.
        </h3>
      </div>
    </div>
    <div class="row justify-content-center mt-5">
      <div class="col-md-7 text-center rowschatten">
        <karussell2 />
      </div>
    </div>

    <div class="row justify-content-center mt-5">
      <div class="col-md-7 text-start">
        <ul>
          <li class="py-3">
            <h4>
              Mitteldeutscher Rundfunk in Erfurt -
              <span class="fw-bold">Generalunternehmer</span> für Trockenbau, Innentüren,
              Maler- und Bodenbelagarbeiten
            </h4>
          </li>
          <li class="py-3">
            <h4>
              Verschiedene<span class="fw-bold">Hotels</span> in Bayern und Thüringen -
              Trockenbauarbeiten seit mehreren Jahren
            </h4>
          </li>
          <li class="py-3">
            <h4>
              Verschiedene <span class="fw-bold">Einkaufscentren</span> deutschlandweit
            </h4>
          </li>
          <li class="py-3">
            <h4>
              <span class="fw-bold">Mehr als 150 Apothekenumbauten</span> deutschlandweit
              - Generalunternehmer für alle baurelevanten Gewerke
            </h4>
          </li>
          <li class="py-3">
            <h4>
              Verschiedene Umbau- und Sanierungsprojekte der
              <span class="fw-bold">Industrie, z. B. Bürogebäude, Werkhallen</span> usw.
            </h4>
          </li>
          <li>
            <h4>Umbau von <span class="fw-bold">Ärztehäusern</span></h4>
          </li>
          <li class="py-3">
            <h4>
              Verschiedene <span class="fw-bold">denkmalgeschützte Gebäude</span>, zum
              Beispiel Schloss Altengottern, Burg Ranis, Klosterkirche Untermertzbach -
              anspruchsvolle Trockenbauarbeiten
            </h4>
          </li>
          <li class="py-3">
            <h4>
              Viele Projekte bei
              <span class="fw-bold">ortsansässigen Industrie- und Gewerbebetrieben</span>
            </h4>
          </li>          
          <li class="py-3">
            <h4>Wohnungsbau / Komfortwohnungen</h4>
          </li>
        </ul>

        <h4 class="py-5">
          Weitere spezielle Referenzen teilen wir Ihnen auf Anfrage gern mit.
        </h4>
      </div>
    </div>
  </div>
  <stickybarTelMail />

  <stickyPfeil />
</template>

<script>
import karussell2 from "../components/karussellSwiper.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";

export default {
  name: "ReferenzenPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    karussell2,
    stickyPfeil,
    stickybarTelMail,
  },
  methods: {},
  computed: {},
};
</script>
